import * as React from 'react';
import Confetti from 'react-confetti';
import { useSelector } from 'react-redux';
import { AccountLink } from '@/lib/navigation/links/AccountLink';
import { UILoader } from '../ui-elements/UILoader';
import { orgCheckoutProcessingResponseMessage, orgCheckoutProcessingResponseStatus } from '../../../redux/app/selectors/organization';
import purchaseSuccess from '../../../../assets/images/static_pages/purchase_success.svg';
import imgError from '../../../../assets/images/static_pages/img_error.svg';

interface CheckoutProcessingProps {
  handleCloseProcessing: () => void;
  showSuccess: boolean;
  setText: (string) => void;
  text: string;
}

export const CheckoutProcessing = ({
  handleCloseProcessing, showSuccess, setText, text,
} : CheckoutProcessingProps) => {
  const responseStatus = useSelector(orgCheckoutProcessingResponseStatus);
  const processingMessage = useSelector(orgCheckoutProcessingResponseMessage);

  React.useEffect(() => setText(processingMessage || 'Submitting...'), [processingMessage]);

  const isError = responseStatus === 'error';
  const errorGraphic = <img className="complete" src={imgError} alt="imgError" />;
  const processingGraphic = isError ? errorGraphic : <UILoader />;
  const successGraphic = <img className="complete" src={purchaseSuccess} alt="purchaseSuccess" />;
  const graphic = showSuccess ? successGraphic : processingGraphic;

  return (
    <div className="avo-ui-3 processing-modal">
      <div className="processing-modal-container-wrap">
        {graphic}
        { showSuccess && <p className="fsz-24 bold-900 mt-10">Success!</p>}
        { isError && <p className="fsz-24 bold-900">Oh no, something went wrong!</p>}
        <p id="modal-text" className="mt-10 center fsz-16">{text}</p>
        { isError && (
          <div className="mt-20 flex">
            <AccountLink path="support">
              <span className="button pale-green mr-10">Contact Support</span>
            </AccountLink>
            <button
              type="button"
              className="button bright-green"
              onClick={handleCloseProcessing}
            >
              Try Again
            </button>
          </div>
        )}
        { showSuccess && (
          <AccountLink path="billing">
            <span className="button bright-green mt-20">Close</span>
          </AccountLink>
        )}
      </div>
      { showSuccess && (
        <Confetti
          width={window.innerWidth}
          height={window.innerHeight}
        />
      )}
    </div>
  );
};
